export default {
  data: [],
  fileList: []
}
